import Utils from "../../misc/Utils";
import StoriesModel from "./StoriesModel";
import Sliders from "../Sliders";

class DesktopStoriesView {
    constructor(parent) {
        this.parent = parent;
        this.device = 'desktop';
    }
    updateSlidesCount() {
        let $slider = this.parent.$thumbWrapper.parents('.slider-inner');
        let count = this.parent.$thumbWrapper.children().length;
        $slider.attr('data-slides-count', Math.ceil(count / $slider.attr('data-per-slide')));
    }
    closeStories() {
        let $storiesWrapper = jQuery('.stories-wrapper');
        Utils.hideBodyOverlay();
        this.parent.deactivateStory();
        $storiesWrapper.removeClass('open').hide();
    }
    openStories(id, response) {
        let $storiesWrapper = jQuery('.stories-wrapper');
        let prepend = (this.parent.model.activeStory.arrayIndex > StoriesModel._stories.indexOf(id));
        if(typeof response !== 'undefined') {
            let $html = jQuery(response.cargo.html);
            if(prepend) {
                jQuery('.stories-wrapper-inner').prepend($html);
            } else {
                jQuery('.stories-wrapper-inner').append($html);
            }
            $html.find('video').each(function () {
                jQuery(this).storyVideo();
            });
            Utils.initClipboard($html, {container: $storiesWrapper[0]});
        }
        Utils.showBodyOverlay();
        $storiesWrapper.addClass('open').show();
        this.parent.model.activeStory.setId(id);
        this.parent.activateStory();
        this.toggleDirectionControl();
    }
    onFetchStoriesModal(response, prepend){
        if(typeof response !== 'undefined') {
            let $html = jQuery(response.cargo.html);
            if(prepend) {
                jQuery('.stories-wrapper-inner').prepend($html);
            } else {
                jQuery('.stories-wrapper-inner').append($html);
            }
            $html.find('video').each(function () {
                jQuery(this).storyVideo();
            });
            Utils.initClipboard($html, {container: jQuery('.stories-wrapper')[0]});
        }
        this.toggleDirectionControl();
    }
    onFetchStoriesThumbs(stories, prepend){
        for(let index in stories) {
            if(prepend) {
                this.parent.$thumbWrapper.prepend(this.parent.getStoryThumb(stories[index]));
            } else {
                this.parent.$thumbWrapper.append(this.parent.getStoryThumb(stories[index]));
            }
        }
        if(this.parent.isSlider) {
            this.updateSlidesCount();
        }
        this.toggleDirectionControl();
        if(jQuery('.stories-wrapper.open').length === 0) {
            return;
        }
        let idToFetch = stories[0].id;
        this.parent.model.fetchStoriesModalByIds([idToFetch], (response) => {
            let $storiesWrapper = jQuery('.stories-wrapper');
            if(typeof response !== 'undefined') {
                let $html = jQuery(response.cargo.html);
                if(prepend) {
                    jQuery('.stories-wrapper-inner').prepend($html);
                } else {
                    jQuery('.stories-wrapper-inner').append($html);
                }
                $html.find('video').each(function () {
                    jQuery(this).storyVideo();
                });
                Utils.initClipboard($html, {container: $storiesWrapper[0]});
                this.toggleDirectionControl();
            }
        });
    }
    onSliderScrollFetch($button, prepend){
        let $icon = $button.find('.icon');
        if((prepend && !this.parent.model.shouldFetchLeft) || (!prepend && !this.parent.model.shouldFetchRigh)) {
            return Sliders.onSliderScroll(this.parent.$sliderInner, prepend? 'left':'right');
        }
        $icon.removeClass($icon.attr('data-inactive-class')).addClass($icon.attr('data-active-class'));
        this.parent.model.fetchStoriesThumbs(prepend, (stories) => {
            if(typeof stories !== 'undefined') {
                this.onFetchStoriesThumbs(stories, prepend);
            }
            $icon.removeClass($icon.attr('data-active-class')).addClass($icon.attr('data-inactive-class'));
            Sliders.onSliderScroll(this.parent.$sliderInner, prepend? 'left':'right');
        }, () => {
            $icon.removeClass($icon.attr('data-active-class')).addClass($icon.attr('data-inactive-class'));
            Sliders.onSliderScroll(this.parent.$sliderInner, prepend? 'left':'right');
        });
    }
    onSliderScroll(evt, $button) {
        let direction = $button.attr('data-slider-scroll');
        if(direction === 'left') {
            if(this.parent.$sliderInner.attr('data-slide-index') === '1'){
                evt.stopPropagation();
                this.onSliderScrollFetch($button, true);
            }
        } else {
            if(this.parent.$sliderInner.attr('data-slide-index') === this.parent.$sliderInner.attr('data-slides-count') ){
                evt.stopPropagation();
                this.onSliderScrollFetch($button, false);
            }
        }
    }
    toggleDirectionControl(){
        let leftControl = jQuery('[data-stories-direction="prev"]');
        let rightControl = jQuery('[data-stories-direction="next"]');
        leftControl.hide();
        rightControl.hide();
        if(this.parent.model.activeStory.arrayIndex > 0) {
            leftControl.show();
        }
        if(this.parent.model.activeStory.arrayIndex < StoriesModel._stories.length - 1) {
            rightControl.show();
        }
    }
}

export default DesktopStoriesView;